import _ from 'underscore';
import { useCallback, useState, useRef, } from 'react';

export const useSearchBoxState = ({ logger, handleUsage, defaultSearchText = '' }) => {
  const [searchText, setSearchText] = useState(defaultSearchText);
  const searchTextValueRef = useRef('');
  const onSearchTextChanging = useCallback((evt, newValue) => {
    searchTextValueRef.current = newValue || '';
  }, []);

  const onSearchTextBlur = useCallback(() => {
    setSearchText(searchTextValueRef.current);
  }, []);

  const onSearchTextChange = useCallback((newValue) => {
    if (newValue !== searchText) {
      logger.logTrace('start searching text', { searchText: newValue });
      setSearchText(newValue);
    }
    if (handleUsage) {
      handleUsage();
    }
  }, [logger, searchText, handleUsage]);

  const onSearchTextClear = useCallback(() => {
    if (!_.isEmpty(searchText)) {
      logger.logTrace('start searching text', { searchText: '<empty>' });
      setSearchText('');
      searchTextValueRef.current = '';
    }
  }, [logger, searchText]);

  return {
    searchText,
    onSearchTextChanging,
    onSearchTextBlur,
    onSearchTextChange,
    onSearchTextClear,
  };
};
